// src/components/WhatPATisNot.jsx
import React from "react";

export default function WhatPATisNot() {
  return (
    <section
      className="mt-4 text-gray-300 space-y-4 leading-relaxed text-sm"
      aria-labelledby="what-pat-is-not-heading"
    >
      <h2
        id="what-pat-is-not-heading"
        className="text-lg font-bold text-gray-100 mb-2"
      >
        What PAT is Not
      </h2>

      <ul className="list-disc list-inside space-y-2">
        <li>
          <strong>Probability Analysis Theory™ (PAT)</strong> is{" "}
          <strong>not</strong> a truth engine. It does not determine what is
          objectively true; it evaluates how justified an interpretation or
          conclusion is under stated assumptions, evidence conditions, and model
          structure.
        </li>

        <li>
          PAT is <strong>not</strong> a formal causal-identification theorem
          prover. It is a causal-question preparation and causal-question
          preparation and structural-audit tool.
        </li>

        <li>
          PAT is <strong>not</strong> a general chatbot, search engine, or
          free-form answer generator. It is a structured reasoning system
          focused on uncertainty, causality, and accountable reasoning.
        </li>

        <li>
          PAT is <strong>not</strong> a substitute for subject-matter expertise
          or human judgement. It provides analytical scaffolding; interpretation
          and decision-making remain the responsibility of the user.
        </li>

        <li>
          PAT is <strong>not</strong> a clinical, legal, or professional
          advisory service. Outputs may support analysis, but they do not
          constitute professional advice.
        </li>

        <li>
          PAT is <strong>not</strong> a guarantee of causal identification. A
          DAG represents hypothesised causal structure, and any causal
          interpretation remains conditional on the adequacy of that structure
          and the assumptions it encodes.
        </li>

        <li>
          PAT is <strong>not</strong> an empirical validation system. It can
          clarify how a causal interpretation is structured and conditionally
          warranted, but it does not replace observation, experiment, or
          domain-specific evidential testing.
        </li>

        <li>
          PAT is <strong>not</strong> designed for speed-first answering. Where
          precision requires staged analysis, variable confirmation, and DAG
          confirmation, processing and user interaction take time.
        </li>
      </ul>
    </section>
  );
}
